import React from "react";
import { AreaIcon, BathroomIcon, BedIcon, CarIcon } from "../assets/icons";

type HouseCardProps = {
  image: string;
  title: string;
  location: string;
  price: number;
  bathrooms: number;
  bedrooms: number;
  parking: number;
  area: number;
  containerClassName?: string;
};

function HouseCard({
  image,
  price,
  title,
  location,
  bathrooms,
  bedrooms,
  parking,
  area,
  containerClassName,
}: HouseCardProps) {
  const features = [
    {
      id: 1,
      icon: <BathroomIcon className="text-grey-400" />,
      count: bathrooms,
    },
    { id: 2, icon: <BedIcon className="text-grey-400" />, count: bedrooms },
    { id: 3, icon: <CarIcon className="text-grey-400" />, count: parking },
    {
      id: 4,
      icon: <AreaIcon className="text-grey-400" />,
      count: `${area}sq.ft`,
    },
  ];

  return (
    <div
      className={`${containerClassName} p-3 bg-grey-100 rounded-lg border-grey-300 border-[1px]`}
    >
      <img
        src={image}
        alt={title}
        className="w-full h-[200px] mb-3 rounded-md transition delay-75 duration-75 ease-in-out object-cover
        hover:scale-105"
      />
      <p className="text-base text-grey-700 font-normal">
        Rs. {price}/- per month
      </p>
      <p className="text-xl text-grey-900 font-medium  ">
        {title}, {location}
      </p>
      <div className="inline-flex gap-5">
        {features.map(({ id, icon, count }) => (
          <div key={id} className="inline-flex items-center gap-1">
            {icon}
            <p className="text-base text-grey-600 font-normal">{count}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default HouseCard;
